import SMRestClient from 'lib/SMRestClient';
import SMFormatHelper from 'components/helpers/SMFormatHelper';

class SMRoomAreaResource {

  static search(queries, completion){
    queries['per_page'] = queries['per_page'] || 20;
    const q = SMFormatHelper.getUrlArgString(queries);
    const apiClient = new SMRestClient();
    apiClient.get('/1/room_areas.json' + q).
      done(function(data, textStatus, xhr) {
        completion(data, null, xhr);
      }).
      fail(function(xhr, textStatus, error) {
        console.error(error);
        completion(null, error, xhr);
      });
  }
}
export default SMRoomAreaResource;


// WEBPACK FOOTER //
// ./app/javascript/resources/SMRoomAreaResource.js